import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { translations } from 'src/i18n/translations';
import { SharedService } from './shared.service';

declare const UIkit: any;

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, private sharedService: SharedService) {}

  deleteAdminFile(id: string): Observable<null> {
    return this.http.delete<null>(`${this.baseUrl}dealflow-files/${id}`);
  }

  getLink(link: string) {
    return this.http.get(link);
  }

  downloadFile(link: string, name: null | string = null, openInNewTab: boolean = true): void {
    const a = document.createElement('a');
    a.href = link;
    a.setAttribute('download', name);
    if (openInNewTab) {
      a.setAttribute('target', '_blank');
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  notifyAboutFileStatus(status: string): void {
    UIkit.notification(
      `
      <div class="uk-text-center">
        ${translations[this.sharedService.language].fileHasBeen} ${status}.
      </div>
    `,
      { pos: 'bottom-center' }
    );
  }

  prepareFile(files: FileList, contentType: string, objectId: string): FormData {
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('description', files[0].name);
    formData.append('content_type', contentType);
    formData.append('object_id', objectId);
    return formData;
  }

  saveCSVFile(data: string, filename: string): void {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    if (url) {
      this.downloadFile(url, `${filename}.csv`);
    }
    window.URL.revokeObjectURL(url);
  }

  uploadFile(data: FormData) {
    return this.http.post<File>(`${this.baseUrl}dealflow-files`, data);
  }
}
